import agent from '../agent'
import {
    FETCH_ELECTION_LIST,
    FETCH_ELECTION_CANDIDATES_LIST,
    ELECTION_COMMENTS_LOADING,
    ELECTION_COMMENTS_LOADED,
    ELECTION_COMMENTS_USER_INFO_LOAD,
    RELATED_ELECTION_LOADED,
    RELATED_ELECTION_LOADING, GET_HOT_TOPICS,
    ELECTION_NEWS_LOADED
} from "../constants/actionTypes"
import {fetchPollyNewsFinished} from "./pollypage";

export const fetchElectionList = (payload) => ({
    type: FETCH_ELECTION_LIST,
    payload
})

export const fetchElections = (dispatch) => (locationId) => {
    agent.Elections.getElection(locationId).then(res => {
        dispatch(fetchElectionList(res));
    })
}

export const fetchElectionCandidatesList = (payload) => ({
    type: FETCH_ELECTION_CANDIDATES_LIST,
    payload
})

export const postFetchHotTopics =(payload)=>({
    type: GET_HOT_TOPICS,
    payload
});

export const fetchElectionCandidates = (dispatch) => (electionId) => {
    agent.Elections.getCandidatesList(electionId).then(res => {
        dispatch(fetchElectionCandidatesList(res));
    })
}

export const fetchHotTopics = (dispatch) => (lan) => {
    agent.HotTopics.getHotTopics(lan).then(res => {
        dispatch(postFetchHotTopics(res));
    })
};

export const fetchElectionCommentsStart = () => ({
    type: ELECTION_COMMENTS_LOADING,
})

export const fetchElecionCommentsFinished = (payload) => ({
    type: ELECTION_COMMENTS_LOADED,
    payload
})

export const fetchElectionCommentList = (dispatch, getState) => (electionID) => {
    dispatch(fetchElectionCommentsStart());
    agent.Elections.getComments(electionID).then(res => {
        commentsUserInfoLoad(res, getState, dispatch);
        dispatch(fetchElecionCommentsFinished(res));
    }, err => {
        dispatch(fetchElecionCommentsFinished(err));
    })
};

export const commentsUserInfoLoad = (commentList, getState, dispatch) => {
    let users = []
    let store = getState();
    let currentUsers = store.commentList && store.commentList.userInfo || {}
    commentList && commentList.forEach(comment => {
        users.push(comment.authorId)
    })
    users = users.filter((value, index, self) => {
        return self.indexOf(value) === index;
    })
    users = users.filter(value=> !currentUsers[value])
    users = users.join(',')
    if (users) {
        agent.Pollies.getCommentsUserInfoList(users).then(res=> {
            const userInfos = {}
            if(res) {
                res.forEach(user=> {
                    userInfos[user.id] = user
                })
                dispatch(setCommentUserInfo(userInfos))
            }
        })
    }
}

export const setCommentUserInfo = (payload) => ({
    type: ELECTION_COMMENTS_USER_INFO_LOAD,
    payload
})

export const addElectionComments = (dispatch, getState) => (electionID, body) => {
    agent.Elections.addComment(electionID, body).then(res => {
        agent.Elections.getComments(electionID).then(res1 => {
            commentsUserInfoLoad(res1, getState, dispatch);
            dispatch(fetchElecionCommentsFinished(res1));
        }, err => {
            dispatch(fetchElecionCommentsFinished(err));
        })
    })
};

export const fetchRelatedElectionStart = () => ({
    type: RELATED_ELECTION_LOADING,
})

export const fetchRelatedElectionFinished = (payload) => ({
    type: RELATED_ELECTION_LOADED,
    payload
})

export const setElectionNewsPosts = (payload) => ({
    type: ELECTION_NEWS_LOADED,
    payload
})

export const fetchRelatedElections = (dispatch) => (electionID) => {
    dispatch(fetchRelatedElectionStart());
    agent.Elections.getRelatedElections(electionID).then(res => {
        dispatch(fetchRelatedElectionFinished(res));
    }, err => {
        dispatch(fetchRelatedElectionFinished(err));
    })
};

export const fetchElectionNewsList = (dispatch) => (person,name,electionID) => {
  agent.Pollies.newsSearchForTag(person,name,electionID).then(res => {
    if(res && res.length > 0) {
      let tags = []
      res.forEach(tag => {
        tags.push(tag.id)
      })
      tags = tags.join(',')
      agent.Pollies.getNewsList(tags).then(news=> {
        if(news) {
          dispatch(setElectionNewsPosts(news));
        }
      })
    }
  })
};
